export default __webpack_public_path__ + "static/media/IMG_20190213_121033_2.74d8aa77.png";